export const getFirebaseErrorMessage = (error) => {
  if (!error) {
    return 'An unexpected error occurred. Please try again.';
  }
  // Extract the error code from the error message if available
  const errorCode = error.code || '';

  switch (errorCode) {
    case 'auth/invalid-credential':
      return 'Invalid email or password. Please check your credentials and try again.';
    case 'auth/user-not-found':
      return 'No account found with this email address.';
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    case 'auth/email-already-in-use':
      return 'An account with this email already exists.';
    case 'auth/weak-password':
      return 'Password is too weak. Please use at least 6 characters.';
    case 'auth/invalid-email':
      return 'Invalid email address format.';
    case 'auth/operation-not-allowed':
      return 'This login method is not enabled. Please contact support.';
    case 'auth/too-many-requests':
      return 'Too many failed attempts. Please try again later.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your internet connection.';
    case 'auth/popup-closed-by-user':
      return 'Sign in popup was closed before completion.';
    case 'auth/cancelled-popup-request':
      return 'Only one popup sign in request allowed at a time.';
    case 'auth/popup-blocked':
      return 'Sign in popup was blocked by the browser.';
    default:
      return error.message || 'An unexpected error occurred. Please try again.';
  }
}; 
